<template>
  <v-content
    class="main--text">
    <TeacherLoggedInAppToolBar
      v-if="!Loading&&isLoggedIn"
      @changeUserState="onChangeUserState"
    />
    <router-view
      v-if="!Loading&&isLoggedIn"/>
    <div
      v-else
      class="max-height">
      <Loading/>
    </div>
  </v-content>
</template>

<script>
import { app } from '@/core/firebase.js'
import { TeacherRepository } from '@/repository/TeacherRepository.js'
import TeacherLoggedInAppToolBar from '@/components/organisms/teacher/TeacherLoggedInAppToolBar.vue'
import Loading from '@/components/organisms/Loading.vue'
import { firestore } from '@/repository/client/firestore.js'

export default {
  name: 'TeacherBase',
  data() {
    return {
      Loading: true,
      teacher: null
    }
  },
  components: {
    'TeacherLoggedInAppToolBar': TeacherLoggedInAppToolBar,
    'Loading': Loading,

  },
  created: function() {
    app.auth().onAuthStateChanged(async user => {
      if (user) {
        try {
          const repo = new TeacherRepository(firestore)
          this.teacher = await repo.find(user.uid)
          this.$store.commit('loginAsTeacher', this.teacher)
          this.Loading = false
        } catch(e) {
          await app.auth().signOut()
          this.$store.commit('logoutAsTeacher')
          this.$router.push('/teacher/top')
        }
      } else {
        this.Loading = false
      }
    })
  },
  methods: {
    onChangeUserState() {
      this.teacher = this.$store.getters.teacher
    }
  },
  computed: {
    isLoggedIn() {
      return this.teacher !== null
    }
  }
}
</script>

<style scoped>
.max-height {
  height: 100%;
}
</style>

